// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { SystemStatus } from '../../interfaces/system-status.interface';

@Component({
  selector: 'app-system-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './system-status.component.html',
  styleUrl: './system-status.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SystemStatusComponent {
  @Input() systemStatus: SystemStatus[] = [];
  @Input() isSystemStatusLoading = false;
}
